import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../stores/redux.store';
import { useNavigateSoftOrHard } from '../../../utilities/hooks/useNavigateSoftOrHard';
import { setGlobalStateLoading } from '../../../utilities/hooks/useGlobalPageState';

export const useOrgLoginConfigAutoRedirect = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigateSoftOrHard();
  const orgLoginConfigAutoRedirect = useAppSelector(state => state.orgLoginConfig.autoRedirect);
  const orgLoginConfigSamlConnectionId = useAppSelector(
    state => state.orgLoginConfig.samlConnectionId
  );

  useEffect(() => {
    if (orgLoginConfigAutoRedirect && orgLoginConfigSamlConnectionId) {
      // Set global state loading to true to keep the page in a loading state during the redirect
      dispatch(setGlobalStateLoading(true));

      navigate(`/login/saml/start?connection=${orgLoginConfigSamlConnectionId}`);
    }
  }, [dispatch, navigate, orgLoginConfigAutoRedirect, orgLoginConfigSamlConnectionId]);
};
